import React from 'react';
import { NoResultsCard } from '@/components/Cards';
import { Trans } from '@lingui/react/macro';
import { ExternalAgreement } from '@/types';
import ExternalAgreementListItem, { ExternalAgreementListItemProps } from './ExternalAgreementListItem';

type ExternalAgreementListProps = Omit<ExternalAgreementListItemProps, 'externalAgreement' | 'defaultExpanded'> & {
    externalAgreements: ExternalAgreement[];
    defaultExpandedId?: number;
};

const ExternalAgreementList: React.FC<ExternalAgreementListProps> = ({ externalAgreements, defaultExpandedId, ...rest }) => {
    return (
        <>
            {externalAgreements.map((externalAgreement) => (
                <ExternalAgreementListItem
                    key={externalAgreement.id}
                    externalAgreement={externalAgreement}
                    defaultExpanded={externalAgreement.id === defaultExpandedId}
                    {...rest}
                />
            ))}

            {externalAgreements.length === 0 && (
                <NoResultsCard>
                    <Trans>No external agreements</Trans>
                </NoResultsCard>
            )}
        </>
    );
};

export default ExternalAgreementList;